module.exports = __webpack_public_path__ + "static/img/3_1_3.b72d12f9.jpg";